exports = module.exports = require("../../../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".property-tax-card {\n  padding: 0px !important; }\n\n.assess-history button div div {\n  height: 35px !important; }\n\n.assess-history button div div {\n  height: 35px !important; }\n\n.pdf-header {\n  display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/AssessmentList/components/PTInformation/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/propertyTax/AssessmentList/components/PTInformation/index.css
// module chunks = 504